import { JwtPayload, decodeJwtPayload } from "../../helpers/token.helper";

const ROLE_CLAIM_KEYS = ["role", "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];

export class UserClaims {
  userId = "";
  email = "";
  fullName = "";
  role = "";
  profileImageUrl = "";
  phone = "";
  expiresAt: Date | null = null;

  static fromToken(token: string): UserClaims | null {
    const payload = decodeJwtPayload(token);
    if (!payload) {
      return null;
    }

    return UserClaims.fromPayload(payload);
  }

  static fromPayload(payload: JwtPayload): UserClaims {
    const claims = new UserClaims();

    claims.userId = payload.sub ?? "";
    claims.email = payload.email ?? "";
    claims.fullName = payload.name ?? "";
    claims.role = ROLE_CLAIM_KEYS.map(key => payload[key]).find(value => typeof value === "string") ?? "";
    claims.profileImageUrl = payload.profile_image_url ?? "";
    claims.phone = payload.phone_number ?? "";
    claims.expiresAt = payload.exp ? new Date(payload.exp * 1000) : null;

    return claims;
  }
}
